import * as e from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/ShieldSlash.es.js";
const o = e.forwardRef((a, r) => /* @__PURE__ */ e.createElement(s, { ref: r, ...a, weights: t }));
o.displayName = "ShieldSlashIcon";
const m = o;
export {
  m as ShieldSlash,
  o as ShieldSlashIcon
};
